import { createContext, useContext } from 'react';

const VehicleCardContext = createContext();

export const useVehicleCardContext = () => useContext(VehicleCardContext);

export default VehicleCardContext;
